import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
         <p style={{ textAlign: "justify" }}>

{/*  Hi Everyone, I am <span className="purple">David Kawadkar </span>
            from <span className="purple"> Gurgaon, India.</span>
            <br />
            I am currently employed as a Software developer at SIEC Education.
            <br />
            I have completed B.Tech in Computer Science and Engineering from Lovely Professional University, Jalandhar.
            <br />
            <br /> */}

         Hi Everyone, I am <span className="purple"> <b> David Kawadkar, </b> </span> 
          an adept Software Developer originating from the bustling cityscape of

        <span className="purple">  Bhopal, India. </span> 
         <br />
         <br />
        Presently, I serve as a dedicated <span className="purple"> Software Developer at SIEC Education, </span> where I contribute to innovative solutions that drive progress and efficiency.
         <br />
         <br />
        I hold a Bachelor's degree in Computer Science and Engineering, proudly obtained from <span className="purple"> Lovely Professional University, Jalandhar. </span> 
  This educational journey has equipped me with a robust foundation in technology and problem-solving skills.
     <br />
     <br />

   
            Apart from coding, some other activities that I love to do!
          </p>
          <ul style = {{lineHeight:"35px"}}>
            <li className="about-activity">
              <ImPointRight /> Exploring immersive PC gaming experiences.
            </li>
            <li className="about-activity">
              <ImPointRight /> Capturing moments through photography.
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling to discover new cultures and landscapes.
            </li>
          </ul>
              
          <br />

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">David</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
